declare namespace $ {

	export class $mol_icon_link extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=link.view.tree.d.ts.map